import * as React from 'react';
import { connect } from 'react-redux'
import * as PBAction from '../../store/actions/powerBIActions'
import * as SA from '../../store/actions/applicationSettingsActions'

import queryString from 'query-string'

import * as SR from '../i4Reports/PowerBIReport';
import '../../css/powerbi.css'

class App extends React.Component<any, any> {
  public constructor(props: any) {
    super(props);

    this.state = {
      clientName: null,
      username: null,
      webapiUrl: null,
      userToken: null,
      reportId: null,
      reportName: null,
      pageId: null,
      passageGroupingId: null,
      grade: null,
    };
  }

  componentDidMount() {
    this.props.loadApplicationSettings();

        const values = queryString.parse(this.props.location.search);

        var clientName = values.clientName;
        var username = values.username;
        var reportId = values.reportId;
        var reportName = values.reportName;
        var pageId = values.pageId;
        var passageGroupingId = values.passageGroupingId;
        var grade = values.grade;

    this.setState({clientName, username, reportId, reportName, pageId, passageGroupingId, grade});
    }

  componentDidUpdate(prevProps) {
    if (prevProps.webapiUrl != this.props.webapiUrl) {
      if (this.props.webapiUrl != null) {
        this.props.getUserToken(this.props.webapiUrl);
      }
    }

    if (prevProps.webapiUrl != this.props.webapiUrl) {
      this.setState({
        webapiUrl: this.props.webapiUrl,
      });
    }

    if (prevProps.userToken != this.props.userToken) {
      this.setState({
        userToken: this.props.userToken,
      });
    }
  }

  render() {
    if (
      this.state.clientName === null ||
      this.state.username === null ||
      this.state.webapiUrl === null ||
      this.state.userToken === null
    ) {
      return null;
    }

    return (
      <div>
        <SR.default
          clientName={this.state.clientName}
          username={this.state.username} // not camelCase in search
          webapiUrl={this.state.webapiUrl}
          userToken={this.state.userToken}
          reportId={this.state != null && this.state.reportId != null? this.state.reportId : null} 
          reportName={this.state != null && this.state.reportName != null ? this.state.reportName : null} 
          pageId={this.state != null && this.state.pageId != null ? this.state.pageId : null} 
          passageGroupingId={this.state != null && this.state.passageGroupingId != null ? this.state.passageGroupingId : null} 
          grade={this.state != null && this.state.grade != null ? this.state.grade : null}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        webapiUrl: state.applicationSettingsReducer.webapiUrl,
        userToken: state.powerBIReducer.userToken,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        loadApplicationSettings: () => dispatch(SA.loadApplicationSettings()),
        getUserToken: (webapiUrl) => dispatch(PBAction.getUserToken(webapiUrl)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/components/app/App.tsx